import React from 'react';

const ContextPopupContext = React.createContext({
  togglePopup: () => { },
});

export default ContextPopupContext;
